<script lang="ts" setup>
const yearsOffset: number = 15
const minYear: number = 1920

const upperDate = computed((): Date => {
    const date = new Date()
    date.setFullYear(date.getFullYear() - yearsOffset)
    return date
})

const lowerDate = computed((): Date => {
    const date = new Date()
    date.setFullYear(minYear)
    return date
})

</script>

<template>
  <FormKitCustomDate
    :data="{
      name: 'birthdate',
      type: 'text',
      label: $t('Dátum narodenia'),
      required: true,
    }"
    :show-reset-btn="false"
    :start-view="'year'"
    :lower-limit="lowerDate"
    :upper-limit="upperDate"
  />
</template>
